// @flow
import React from 'react';
import type { Categories } from 'store/modules/write';
import CategoryEditItem from '../CategoryEditItem';
import './CategoryEditItemList.scss';

type Props = {
  categories: ?Categories,
  onCreate(): void,
  onToggleEditCategory(id: string): void,
  onChange({ id: string, name: string, order: number, parent: string }): void,
  onHideCategory(id: string): void,
  onSelectCategory1(id: string): void,
  onSelectCategory2(id: string): void,
  type: number,
  innerRef(ref: any): void,
};

const CategoryEditItemList = ({
  categories,
  onCreate,
  onToggleEditCategory,
  onChange,
  onHideCategory,
  onSelectCategory1,
  onSelectCategory2,
  type,
  innerRef,
}: Props) => {
  if (!categories) return null;
  const categoryList = categories
    .filter(c => !c.hide)
    .map(category => (
      <CategoryEditItem
        key={category.id}
        id={category.id}
        name={category.name}
        order={category.order}
        parent={category.parent}
        edit={category.edit}
        temp={category.temp}
        onToggleEditCategory={() => onToggleEditCategory(category.id)}
        onChange={(name, order, parent) =>
          onChange({
            id: category.id,
            name,
            order,
            parent,
          })
        }
        onHide={() => onHideCategory(category.id)}
        onSelect={() => {
          if (type === 1) {
            onSelectCategory1(category.id);
          } else if (type === 2) {
            onSelectCategory2(category.id);
          }
        }}
      />
    ));
  return (
    <div className="CategoryEditItemList">
      <div className="create-category util flex-center" onClick={onCreate}>
        <div>{`${type}차 카테고리 추가`}</div>
      </div>
      <div ref={innerRef}>{categoryList}</div>
    </div>
  );
};

export default CategoryEditItemList;



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditItemList/CategoryEditItemList.js